/**
 * Project Task Status Configuration
 *
 * Single source of truth for project task status/column definitions.
 * This file defines the visual appearance and properties of each status column
 * in the project tasks Kanban board.
 */

import { ProjectTaskStatus } from 'shared/types/renovation';

export interface ProjectTaskColumn {
  id: ProjectTaskStatus;
  label: string;
  color: string;
  bgColor: string;
  headerBgColor: string;
  borderColor: string;
  tooltip?: string;
}

/**
 * Project Task Status Columns
 * Defines all available project task status columns with their styling
 */
export const projectTaskColumns: ProjectTaskColumn[] = [
  {
    id: ProjectTaskStatus.TODO,
    label: 'Te doen',
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-50/50',
    headerBgColor: 'bg-neutral-100',
    borderColor: 'border-neutral-300',
    tooltip: 'Taken die nog moeten worden gestart',
  },
  {
    id: ProjectTaskStatus.IN_PROGRESS,
    label: 'In behandeling',
    color: 'text-moss-primary',
    bgColor: 'bg-moss-primary/5',
    headerBgColor: 'bg-moss-primary/10',
    borderColor: 'border-moss-primary/20',
    tooltip: 'Taken waar momenteel aan wordt gewerkt',
  },
  {
    id: ProjectTaskStatus.COMPLETED,
    label: 'Afgerond',
    color: 'text-status-good',
    bgColor: 'bg-status-good/5',
    headerBgColor: 'bg-status-good/10',
    borderColor: 'border-status-good/20',
    tooltip: 'Afgeronde taken',
  },
];
